import primaryFirstSort from '../../../../utils/primaryFirstSort';
function primaryFirstPhoneSort() {
  var phones = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return primaryFirstSort({
    arr: phones,
    sortByProperty: 'phone_type'
  });
}
export default primaryFirstPhoneSort;
//# sourceMappingURL=primaryFirstPhoneSort.js.map